import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-724458cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

import { ref,computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Dialog',
  props: {
  open: { type: Boolean, required: false },
  ok: { type: Function, required: false },
},
  emits: ['update:open'],
  setup(__props, { emit }) {

const props = __props;



const openModal = computed({
  get() {
    return props.open
  },
  set(value: boolean) {
    emit('update:open', value)
  },
})
const loading = ref(false)
const sumbit = async () => {
  loading.value = true
  try {
    typeof props.ok === 'function' && await props.ok()
  } finally {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: openModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((openModal).value = $event)),
    title: _ctx.$t('login.platformPermissions'),
    width: "600",
    "close-on-click-modal": false,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:open', false)))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "enter",
          style: {"margin":"0 auto"},
          onClick: sumbit
        }, [
          (loading.value)
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "el-icon is-loading",
                style: {"margin-left":"5px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Loading)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('login.save')), 1)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["modelValue", "title"]))
}
}

})